import './notification-list.scss'
import { useNotificationBanners } from '@/common/components/notificationBannersList/hooks/useNotificationBanners'
import { NotificationBanner } from '@/common/components/notificationBannersList/notificationBanner/NotificationBanner'

export const NotificationBannersList = () => {
    const { venueBanners, pageBanners } = useNotificationBanners()

    return (
        <div className={'notification-banners-list'}>
            {venueBanners.map(b => (
                <NotificationBanner key={b.nodeId} id={b.nodeId} iconName={b.icon} message={b.message} />
            ))}
            {pageBanners.map(b => (
                <NotificationBanner key={b.nodeId} id={b.nodeId} iconName={b.icon} message={b.message} />
            ))}
        </div>
    )
}
